import { Roles } from "@arelia-types/index";
import { Chip, SxProps } from "@mui/material";
import { ComponentColor } from "src/theme/models";

type Props = {
  role: Roles,
  sx?: SxProps,
  size?: "small" | "medium" | undefined
}

export default function RoleChip({ role, sx, size = "small" }: Props) {
  const colors: Record<Roles, ComponentColor> = {
    [Roles.Admin]: 'success',
    [Roles.TestUser]: 'warning',
    [Roles.Ambassador]: 'info'
  }

  return role ? <Chip color={colors[role] ?? 'success'} label={role} size={size} sx={{ px: 1, textTransform: 'uppercase', ...sx }} /> : <></>;
}